'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var caretDown = require('./caret-down-00294a07.js');

var SelectWrapperStyled = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: inline-flex;\n  height: 48px;\n  position: relative;\n"], ["\n  display: inline-flex;\n  height: 48px;\n  position: relative;\n"])));
var StyledSelect = styled__default.select(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n\n  padding-left: 16px;\n  padding-right: 44px;\n\n  border-radius: 4px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n\n  font-size: 14px;\n  font-family: ", ";\n\n  appearance: none;\n  outline: none;\n\n  &:focus, &:active {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-size: 16px;\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n\n  padding-left: 16px;\n  padding-right: 44px;\n\n  border-radius: 4px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ",
    ";\n\n  font-size: 14px;\n  font-family: ", ";\n\n  appearance: none;\n  outline: none;\n\n  &:focus, &:active {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n\n  @media (max-width: ", ") {\n    font-size: 16px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return (isSelected ? theme.colors.fontColor : theme.colors.greys.adminGreyMediumAlt);
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.depth_2;
}, constants.DIMENSIONS.MEDIUM);
var CaretDownIcon = styled__default(caretDown.CaretDown)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n\n  width: 10px;\n  height: 10px;\n\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"], ["\n  position: absolute;\n\n  width: 10px;\n  height: 10px;\n\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

exports.CaretDownIcon = CaretDownIcon;
exports.SelectWrapperStyled = SelectWrapperStyled;
exports.StyledSelect = StyledSelect;
